var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "videos_group_layer" + _vm.roomGroup.roomGroupId,
      staticClass: "room-group-area-wrapper",
      style: _vm.roomCallGroupStyle,
      attrs: { draggable: "false", "data-group-id": _vm.roomGroup.roomGroupId },
    },
    [
      _c(
        "div",
        {
          staticClass: "room-group-area",
          style: {
            height: `${_vm.roomGroup.videoRectList.height}px`,
          },
        },
        [
          _c("RoomGroupVideoFilmContainer", {
            attrs: { roomGroup: _vm.roomGroup },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }